import { render, staticRenderFns } from "./chatMonitoring.vue?vue&type=template&id=675d00cc&"
import script from "./chatMonitoring.vue?vue&type=script&lang=js&"
export * from "./chatMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('675d00cc')) {
      api.createRecord('675d00cc', component.options)
    } else {
      api.reload('675d00cc', component.options)
    }
    module.hot.accept("./chatMonitoring.vue?vue&type=template&id=675d00cc&", function () {
      api.rerender('675d00cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/chatMonitoring.vue"
export default component.exports